import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    formGroup: {
      marginTop: theme.spacing(4),
      backgroundColor: '#f6f6f6',
    },
  }));